if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"8066": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"2572": 1,
"5318": 1,
"4003": 1,
"5445": 1,
"7526": 1,
"7865": 1,
"6332": 1,
"2437": 1,
"3294": 1,
"2315": 1,
"4827": 1,
"692": 1,
"7510": 1,
"4287": 1,
"7500": 1,
"7637": 1,
"1216": 1,
"4701": 1,
"2989": 1,
"8333": 1,
"3348": 1,
"8143": 1,
"2771": 1,
"1046": 1,
"6538": 1,
"3829": 1,
"1344": 1,
"4549": 1,
"7966": 1,
"4484": 1,
"2991": 1,
"462": 1,
"2121": 1,
"3714": 1,
"8970": 1,
"8794": 1,
"5829": 1,
"4816": 1,
"3928": 1,
"6541": 1,
"5614": 1,
"1255": 1,
"8551": 1,
"1980": 1,
"5538": 1,
"8396": 1,
"957": 1,
"1366": 1,
"3201": 1,
"6754": 1,
"6819": 1,
"6122": 1,
"6014": 1,
"3087": 1,
"680": 1,
"6779": 1,
"8133": 1,
"409": 1,
"8634": 1,
"8173": 1,
"5447": 1,
"6700": 1,
"1347": 1,
"471": 1,
"2952": 1,
"4722": 1,
"1924": 1,
"2221": 1,
"3110": 1,
"2458": 1,
"6769": 1,
"5824": 1,
"5058": 1,
"6828": 1,
"6597": 1,
"9424": 1,
"8271": 1,
"2969": 1,
"4291": 1,
"5643": 1,
"9526": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
